var map = {
	"./africa/welcome-links.vue": [
		"ihoZ",
		3
	],
	"./club-soft/welcome-links.vue": [
		"ApR1",
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "57tb";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/welcome-links lazy ^\.\/.*\/welcome\-links\.vue$
// module id = 57tb
// module chunks = 37